import {
  mdiAttachment,
  mdiCheckCircleOutline,
  mdiChevronLeft,
  mdiChevronDown,
  mdiChevronRight,
  mdiHistory,
  mdiInformationOutline,
  mdiPrinter,
} from "@mdi/js";
import throttle from "lodash/throttle";
import Icon from "@mdi/react";
import axios from "axios";
import moment from "moment";
import { FunctionComponent, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useAuth } from "../../../context_providers/auth/authProvider";
import DrawerWidget from "../../../context_providers/modal/drawer_widget";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  ModalType,
  ModalAlignment,
} from "../../../context_providers/modal/modal_context";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import {
  fetchPost,
  fetchGet,
  fetchDelete,
  toQueryString,
  getHeaders,
} from "../../../service/api_client";
import { UTCToLocalDate } from "../../../utils/date_util";
import { ACTION, file_dir, MODULE } from "../../../utils/enums";
import { currencyFormat } from "../../../utils/currency_format";
import {
  currencies,
  default_mail_detail,
} from "../../accounts/models/party_model";
import { PurchaseVoucherModelV2 } from "../../accounts/models/purchase_model";
import {
  AttachmentModel,
  auto_approval_amount,
  po_approval_status,
  getAprrovalLevel,
  PurchaseOrderModelV2,
  PoItemV2,
  po_default_value_v2,
  POType,
} from "../model/purchase_order_model";
import PoSnapSection from "./components/po_snaps";
import { ProcurementProjectModel } from "../project/model/project_model";
import {
  CategoryOfExpenseOptions,
  PaymentModeOptions,
  PaymentRequestModel,
  payment_request_default,
} from "../model/payment_request_model";
import RequiredMark from "../../../ui/new_components/common/required_mark";
import ActionHistory from "./components/transfer_logs";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import ModalDialog from "../../../ui/new_components/common/modal";
import "../../../styles/responsive_shrink.css";
import {
  createPaymentRequestPayment,
  getExchangeRate,
  getPaymentList,
  getProcurementAttachmentPRESignedURL,
  postProcurementAttachmentS3,
  UpdateDisputeStatusByPONoApi,
} from "./service/purchase_order_repository";
import { usePurchaseOrder } from "../contexts/po-creation-context";
import { POLineItemCard } from "./components/po_line_item_card";
import AttachmentSectionV2 from "./components/attachment_widget_v2";
import { urls } from "../../../utils/urls";
import PoViewBottomSheetWidget from "./components/bottom_sheet_view";
import { FieldType } from "../../../procurement/components/create_view/form_field";
import NewTableView from "../../../procurement/components/new_table_comp";
import { GetPurchaseVoucherList } from "../../accounts/purchase/repo/purchase_voucher_repo";
import { generate_id } from "../../inventory/journals/destination_stock_voucher/components/item_row_status";
import { sendToTyno } from "../../purchase_order_report/service/po_report_repo";

interface PurchaseOrderDetailScreenProps {}

const ReadField: FunctionComponent<{
  label: string;
  value?: any;
  className?: string;
}> = ({ label, value, className }) => (
  <div className={`flex flex-col ${className ?? ""}`}>
    <span className="text-gray-400 text-xs">{label}</span>
    <span className="font-semibold break-words text-gray-600">
      {value === undefined || value === null || value === "" ? "--" : value}
    </span>
  </div>
);

const PurchaseOrderDetailScreen: FunctionComponent<
  PurchaseOrderDetailScreenProps
> = (props) => {
  const { user, isAuthorised } = useAuth();
  const navigation = useHistory();
  const { purchaseOrder, setPurchaseOrder } = usePurchaseOrder();
  const { id } = useParams<{ id: string }>();
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;
  const [loading, setLoading] = useState(false);
  const [showCreatePaymentRequestModal, setShowCreatePaymentRequestModal] =
    useState(false);
  const [showResolveDisputeModal, setShowResolveDisputeModal] = useState(false);
  const [resolveRemark, setResolveRemark] = useState("");
  const { showToast } = useToast();
  const [showHistory, setShowHistory] = useState<any>();
  const [showHistory1, setShowHistory1] = useState<any>();

  const [showPRTable, setShowPRTable] = useState<boolean>(false);
  const [paymentRequestList, setPaymentRequestList] = useState<
    PaymentRequestModel[]
  >([]);

  const [showInwardTable, setShowInwardTable] = useState<boolean>(false);
  const [inwardList, setInwardList] = useState<PurchaseVoucherModelV2[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [project, setProject] = useState<ProcurementProjectModel>();

  const [prvData, setPrvData] = useState<PurchaseOrderModelV2>({
    ...po_default_value_v2,
    shipping_profile: {
      ...default_mail_detail,
      contact_name: user?.first_name + " " + (user?.last_name || ""),
      contact_mobile: user?.mobile || "",
      contact_email: user?.email || "",
    },
  });
  const [percent, setPercent] = useState<number>(0);
  const [amount, setAmount] = useState<any>();
  const [invoiceAmount, setInvoiceAmount] = useState<any>();
  const [advancePaymentFileList, setAdvancePaymentFileList] = useState<File[]>(
    [],
  );
  const [againstInvoiceFileList, setAgainstInvoiceFileList] = useState<File[]>(
    [],
  );
  const [paymentRequestType, setPaymentRequestType] = useState("advance"); // Track selected payment type
  const [paymentRequest, setPaymentRequest] = useState<PaymentRequestModel>({
    ...payment_request_default,
  });
  const [isWarehouseOperator, setIsWarehouseOperator] = useState(false);
  const [isPOAmender, setIsPOAmender] = useState(false);
  const [procuremntRead, setProcurementRead] = useState(false);
  const [canUpdatePartialPO, setCanUpdatePartialPO] = useState(false);
  const showDisputeActionsOnly =
    isPOAmender && purchaseOrder.status === "Disputed";

  const serviceItems = purchaseOrder.items.filter(
    (i) => i.line_type === "service" && i.is_payable,
  );

  const inventoryItems = purchaseOrder.items.filter(
    (i) => i.line_type !== "service",
  );
  const inventoryValue = inventoryItems.reduce(
    (sum, i) => sum + i.unit_no * i.price,
    0,
  );

  const handleCancelPaymentRequest = async () => {
    resetForm();
  };

  const handlePaymentAmount = (e: any) => {
    const amount = Number(e.target.value);
    if (!paymentRequest?.invoice_amount) {
      showToast({
        type: ToastType.error,
        text: "Please enter invoice amount first",
      });
      return;
    }

    setPaymentRequest({
      ...paymentRequest,
      payment_amount: amount,
    });
  };

  const handleCreateAdvancePaymentRequest = async () => {
    if (isSubmitting) return; // Block if already submitting

    setIsSubmitting(true);
    setLoading(true);

    try {
      // Validation checks
      if (amount < paymentRequest.payment_amount) {
        return showToast({
          type: ToastType.error,
          text: "Amount should not be greater than total amount: " + amount,
        });
      }

      if (!paymentRequest.payment_amount || !paymentRequest.percentage) {
        return showToast({
          type: ToastType.error,
          text: "Please enter all values!",
        });
      }

      if ((paymentRequest?.pi_amount ?? 0) > 0) {
        if ((paymentRequest?.pi_amount ?? 0) < paymentRequest?.payment_amount) {
          return showToast({
            type: ToastType.error,
            text: "Payment amount cannot be more than pi amount.",
          });
        }
      }

      // Update payment request with PO details
      paymentRequest.po_no = purchaseOrder.po_no;
      paymentRequest.vendor = purchaseOrder.party?.name;
      paymentRequest.project = purchaseOrder.project;
      paymentRequest.po_date = purchaseOrder.created_at;
      paymentRequest.po_approval = purchaseOrder.approval_status;
      paymentRequest.po_id = purchaseOrder.id;
      paymentRequest.type = "ADVANCE";

      // Get pre-signed URLs for file upload
      const pre_signed_url_list = await getProcurementAttachmentPRESignedURL(
        advancePaymentFileList,
      );

      if (!pre_signed_url_list) {
        return showToast({
          type: ToastType.error,
          text: "Error in getting signed URL",
        });
      }

      // Upload attachments
      for (let i = 0; i < pre_signed_url_list.length; i++) {
        const [signed_url, file, attachment] = pre_signed_url_list[i];
        const res = await postProcurementAttachmentS3(
          signed_url,
          file,
          attachment,
        );

        if (!res) {
          return showToast({
            type: ToastType.error,
            text: "Error in uploading attachments",
          });
        }
      }

      // Add new attachments to the payment request
      const newAttachments = pre_signed_url_list.map(
        ([, , attachment]) => attachment,
      );
      const updatedState = {
        ...paymentRequest,
        attachments: [...paymentRequest.attachments, ...newAttachments],
      };

      // Create the payment request
      const create_payment_request_response =
        await createPaymentRequestPayment(updatedState);

      setPaymentRequest(updatedState);

      if (create_payment_request_response.success) {
        showToast({
          type: ToastType.success,
          text: create_payment_request_response.message,
        });
        resetForm();
        fetchLinkedInwardsAndPRData();
      } else {
        showToast({
          type: ToastType.error,
          text: create_payment_request_response.error,
        });
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text:
          error.message || "An error occurred while creating payment request",
      });
    } finally {
      setIsSubmitting(false);
      setLoading(false);
      setShowCreatePaymentRequestModal(false);
    }
  };

  const handleCreateAgainstInvoicePaymentRequest = async () => {
    if (isSubmitting) return; // Block if already submitting

    setIsSubmitting(true);
    setLoading(true);

    try {
      // Check if payment request can be created
      const result = await fetchGet(
        url +
          `/advance_payment_request/can-create-pr?po_no=${purchaseOrder.po_no}`,
        {
          params: { po_no: purchaseOrder.po_no },
        },
      );

      if (!result.success || result.allowed === false) {
        return showToast({
          type: ToastType.error,
          text: result.reason || "Cannot create payment request",
        });
      }

      // Validation checks
      if (
        !paymentRequest.invoice_no ||
        !paymentRequest.payment_amount ||
        !paymentRequest.invoice_date ||
        againstInvoiceFileList.length === 0
      ) {
        return showToast({
          type: ToastType.error,
          text: "Please enter all values!",
        });
      }

      if (
        invoiceAmount < paymentRequest.payment_amount ||
        (paymentRequest?.invoice_amount ?? 0) < paymentRequest?.payment_amount
      ) {
        return showToast({
          type: ToastType.error,
          text: `Payment Amount cannot be greater than invoice amount!, available amount is: ${paymentRequest?.invoice_amount}`,
        });
      }

      // Update payment request with PO details
      paymentRequest.po_no = purchaseOrder.po_no;
      paymentRequest.vendor = purchaseOrder.party?.name;
      paymentRequest.project = purchaseOrder.project;
      paymentRequest.po_date = purchaseOrder.created_at;
      paymentRequest.po_approval = purchaseOrder.approval_status;
      paymentRequest.po_id = purchaseOrder.id;
      paymentRequest.type = "AGAINST INVOICE";

      // Get pre-signed URLs for file upload
      const against_invoice_pre_signed_urls =
        await getProcurementAttachmentPRESignedURL(againstInvoiceFileList);

      if (!against_invoice_pre_signed_urls) {
        return showToast({
          type: ToastType.error,
          text: "Error in getting signed URL",
        });
      }

      // Upload attachments
      for (let i = 0; i < against_invoice_pre_signed_urls.length; i++) {
        const [signed_url, file, attachment] =
          against_invoice_pre_signed_urls[i];
        const res = await postProcurementAttachmentS3(
          signed_url,
          file,
          attachment,
        );

        if (!res) {
          return showToast({
            type: ToastType.error,
            text: "Error in uploading attachments",
          });
        }
      }

      // Add new attachments to the payment request
      const newAttachments = against_invoice_pre_signed_urls.map(
        ([, , attachment]) => attachment,
      );
      const againstInvoiceUpdatedState = {
        ...paymentRequest,
        attachments: [...paymentRequest.attachments, ...newAttachments],
      };

      // Create the payment request
      const create_payment_request_response = await createPaymentRequestPayment(
        againstInvoiceUpdatedState,
      );

      setPaymentRequest(againstInvoiceUpdatedState);

      if (create_payment_request_response.success) {
        showToast({
          type: ToastType.success,
          text: create_payment_request_response.message,
        });
        resetForm();
        fetchLinkedInwardsAndPRData();
      } else {
        showToast({
          type: ToastType.error,
          text: create_payment_request_response.error,
        });
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text:
          error.message || "An error occurred while creating payment request",
      });
    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  // Main handler function that calls the appropriate function based on payment type
  const handleCreatePaymentRequest = async () => {
    if (paymentRequestType === "advance") {
      await handleCreateAdvancePaymentRequest();
    } else {
      await handleCreateAgainstInvoicePaymentRequest();
    }
  };

  // Updated resetForm function
  const resetForm = () => {
    setPaymentRequestType("advance");
    setPaymentRequest(payment_request_default);
    setAdvancePaymentFileList([]);
    setAgainstInvoiceFileList([]);
    setShowCreatePaymentRequestModal(false);
    setIsSubmitting(false);
    setLoading(false); // Also reset loading state
  };

  useEffect(() => {
    const warehouse_operator_permission = isAuthorised({
      module: MODULE.warehouse_operator,
      action: ACTION.READ,
    });

    const procuremnt_read_only = isAuthorised({
      module: MODULE.procurement_read_only,
      action: ACTION.READ,
    });

    const is_po_amender = isAuthorised({
      module: MODULE.po_amender,
      action: ACTION.UPDATE,
    });

    setProcurementRead(procuremnt_read_only);
    setCanUpdatePartialPO(
      isAuthorised({ module: MODULE.update_partial_po, action: ACTION.UPDATE }),
    );

    setIsWarehouseOperator(warehouse_operator_permission);
    setIsPOAmender(is_po_amender);

    if (id) getData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorised]);

  const getCurrencyExchangeRate = async () => {
    try {
      setLoading(true);
      const formattedDate = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"

      const exchangeRate = await getExchangeRate({
        from: "USD",
        to: "INR",
        date: formattedDate,
      });

      setPurchaseOrder((o) => ({
        ...o,
        vendor_currency_to_inr: exchangeRate ?? 0,
      }));
    } catch (error) {
      console.error("Error getting exchange rate:", error);
    } finally {
      setLoading(false);
    }
  };

  const getData = async (id: string) => {
    setLoading(true);
    const res = await fetchGet(url + "/" + id);
    if (res.success) {
      if (!res.data.vendor_currency) {
        res.data.vendor_currency = currencies.rupee;
        res.data.vendor_currency_to_inr = 1;
      }

      if (res.data.items === undefined || res.data.items === null) {
        res.data.items = [];
      }
      res.data.items = res.data.items.map((it: PoItemV2) =>
        it.id ? it : { ...it, id: generate_id() },
      );

      setPurchaseOrder({ ...res.data });
      setPrvData({ ...res.data });
    } else {
      showToast({ type: ToastType.error, text: res.error });
    }
    setLoading(false);
  };

  useEffect(() => {
    purchaseOrder.subtotal = 0;
    purchaseOrder.sgst = 0;
    purchaseOrder.cgst = 0;
    purchaseOrder.igst = 0;

    if (Array.isArray(purchaseOrder.items) && purchaseOrder.items.length > 0) {
      if (purchaseOrder?.type === POType["Job Work PO"]) {
        serviceItems.forEach((item) => {
          const itemTotal = item.unit_no * item.price;
          purchaseOrder.subtotal += itemTotal;

          let gstRate = item.item.tax_detail?.gst_rate || 0;

          const taxAmount = gstRate ? (itemTotal * gstRate) / 100 : 0;
          const billToState = purchaseOrder.bill_to?.address?.state || "";
          const partyState =
            purchaseOrder.party?.mail_detail?.address?.state || "";

          const isInterStateTransaction =
            billToState !== "" &&
            partyState !== "" &&
            billToState.toLowerCase() !== partyState.toLowerCase();

          if (isInterStateTransaction) {
            if (purchaseOrder.vendor_currency.short_name !== "INR") {
              purchaseOrder.igst +=
                taxAmount / purchaseOrder.vendor_currency_to_inr;
              purchaseOrder.cgst = 0;
              purchaseOrder.sgst = 0;
            } else {
              purchaseOrder.igst += taxAmount;
              purchaseOrder.cgst = 0;
              purchaseOrder.sgst = 0;
            }
          } else {
            const sgst = taxAmount / 2.0;
            const cgst = taxAmount / 2.0;

            if (purchaseOrder.vendor_currency.short_name !== "INR") {
              purchaseOrder.sgst += sgst / purchaseOrder.vendor_currency_to_inr;
              purchaseOrder.cgst += cgst / purchaseOrder.vendor_currency_to_inr;
            } else {
              purchaseOrder.sgst += sgst;
              purchaseOrder.cgst += cgst;
            }
          }

          const party = purchaseOrder.party;

          if (party.tax_detail.reg_type === "Unregistered") {
            purchaseOrder.cgst = 0;
            purchaseOrder.sgst = 0;
            purchaseOrder.igst = 0;
          }
        });
      } else {
        purchaseOrder.items.forEach((item) => {
          const itemTotal = item.unit_no * item.price;
          purchaseOrder.subtotal += itemTotal;

          let gstRate = item.item.tax_detail?.gst_rate || 0;

          const taxAmount = gstRate ? (itemTotal * gstRate) / 100 : 0;
          const billToState = purchaseOrder.bill_to?.address?.state || "";
          const partyState =
            purchaseOrder.party?.mail_detail?.address?.state || "";

          const isInterStateTransaction =
            billToState !== "" &&
            partyState !== "" &&
            billToState.toLowerCase() !== partyState.toLowerCase();

          if (isInterStateTransaction) {
            if (purchaseOrder.vendor_currency.short_name !== "INR") {
              purchaseOrder.igst +=
                taxAmount / purchaseOrder.vendor_currency_to_inr;
              purchaseOrder.cgst = 0;
              purchaseOrder.sgst = 0;
            } else {
              purchaseOrder.igst += taxAmount;
              purchaseOrder.cgst = 0;
              purchaseOrder.sgst = 0;
            }
          } else {
            const sgst = taxAmount / 2.0;
            const cgst = taxAmount / 2.0;

            if (purchaseOrder.vendor_currency.short_name !== "INR") {
              purchaseOrder.sgst += sgst / purchaseOrder.vendor_currency_to_inr;
              purchaseOrder.cgst += cgst / purchaseOrder.vendor_currency_to_inr;
            } else {
              purchaseOrder.sgst += sgst;
              purchaseOrder.cgst += cgst;
            }
          }

          const party = purchaseOrder.party;

          if (party.tax_detail.reg_type === "Unregistered") {
            purchaseOrder.cgst = 0;
            purchaseOrder.sgst = 0;
            purchaseOrder.igst = 0;
          }
        });
      }
    }

    purchaseOrder.total =
      purchaseOrder.subtotal +
      (purchaseOrder.cgst ?? 0) +
      (purchaseOrder.sgst ?? 0) +
      (purchaseOrder.igst ?? 0);

    if (purchaseOrder.total <= auto_approval_amount) {
      // no approval required
      purchaseOrder.approval_required = false;
      purchaseOrder.approval_status = po_approval_status.approved;
    } else {
      // approval required
      if (prvData.approval_status === po_approval_status.approved) {
        // already approved
        if (purchaseOrder.total > prvData.total) {
          //new total > old total
          purchaseOrder.approval_required = true;
          purchaseOrder.approval_status = po_approval_status.pending;
        } else {
          purchaseOrder.approval_required = prvData.approval_required;
          purchaseOrder.approval_status = prvData.approval_status;
        }
      } else {
        // already not approved
        purchaseOrder.approval_required = prvData.approval_required;
        purchaseOrder.approval_status = prvData.approval_status;
      }
    }

    purchaseOrder.approval_level = purchaseOrder.approval_level =
      purchaseOrder.vendor_currency.short_name === currencies.rupee.short_name
        ? getAprrovalLevel(purchaseOrder.total)
        : getAprrovalLevel(
            purchaseOrder.total * purchaseOrder.vendor_currency_to_inr,
          );
    setPurchaseOrder({ ...purchaseOrder });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    purchaseOrder.items,
    purchaseOrder.vendor_currency,
    purchaseOrder.vendor_currency_to_inr,
    purchaseOrder.bill_to,
    purchaseOrder.party,
  ]);

  useEffect(() => {
    purchaseOrder.total =
      purchaseOrder.subtotal +
      purchaseOrder.cgst -
      purchaseOrder.sgst -
      (purchaseOrder.paid ?? 0);

    if (purchaseOrder.total <= auto_approval_amount) {
      purchaseOrder.approval_required = false;
      purchaseOrder.approval_status = po_approval_status.approved;
    } else {
      // approval required

      if (prvData.approval_status === po_approval_status.approved) {
        // already approved

        if (purchaseOrder.total > prvData.total) {
          //new total > old total

          purchaseOrder.approval_required = true;
          purchaseOrder.approval_status = po_approval_status.pending;
        } else {
          purchaseOrder.approval_required = prvData.approval_required;
          purchaseOrder.approval_status = prvData.approval_status;
        }
      } else {
        // already not approved

        purchaseOrder.approval_required = prvData.approval_required;
        purchaseOrder.approval_status = prvData.approval_status;
      }
    }
    setPurchaseOrder({ ...purchaseOrder });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    prvData,
    purchaseOrder.taxes,
    purchaseOrder.discounts,
    purchaseOrder.discounts,
  ]);

  const [showAttachment, setShowAttachment] = useState(false);
  const history = useHistory();
  const [attachmentKey, setAttachmentKey] = useState(Math.random() * 10000);
  const [showSnaps, setShowSnaps] = useState(false);
  const existingItems = purchaseOrder.items || [];

  useEffect(() => {
    if (paymentRequestType === "advance") {
      setPaymentRequest({
        ...paymentRequest,
        type: "ADVANCE",
      });
    } else {
      setPaymentRequest({
        ...paymentRequest,
        type: "AGAINST INVOICE",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentRequestType]); // This will log every time paymentRequest changes

  const handleInvoiceAmount = throttle(async (e: any) => {
    const amount = Number(e.target.value);
    setPaymentRequest({
      ...paymentRequest,
      invoice_amount: amount,
    });
    // Trigger validation and API logic
    await getInvoiceAmount(amount);
  }, 0);

  const getInvoiceAmount = throttle(async (amount: number) => {
    try {
      // Fetch the current total percentage from the backend
      const res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/advance_payment_request/get-percentage/${purchaseOrder.po_no}`,
      );
      const po_total =
        purchaseOrder?.subtotal +
          purchaseOrder?.cgst +
          purchaseOrder?.sgst +
          purchaseOrder?.igst || 0;

      setInvoiceAmount((po_total ?? 0) - res.totalAmount);
      if (res.success) {
        const totalAmount = res.totalAmount;
        if (po_total - totalAmount < amount) {
          showToast({
            type: ToastType.error,
            text: "Please enter correct invoice amount",
          });
          return;
        }
        setPaymentRequest({
          ...paymentRequest,
          invoice_amount: amount,
        });
      }
    } catch (error: any) {
      console.error("Error fetching percentage:", error);
      showToast({
        type: ToastType.error,
        text: error.message || "An unexpected error occurred.",
      });
    }
  }, 0);

  const handlePercentageChange = throttle((e: any) => {
    const percentage = Number(e.target.value);

    // Update state immediately for responsive input
    setPaymentRequest((prev) => ({
      ...prev,
      payment_amount: 0,
      percentage: percentage,
    }));

    // Trigger validation and API logic
    getPaymentAmount(percentage);
  }, 0);

  const getPaymentAmount = throttle(async (percentage: number) => {
    if (percentage < 0) {
      showToast({
        type: ToastType.error,
        text: "Please enter a valid percentage.",
      });
      return;
    }

    try {
      // Fetch the current total percentage from the backend
      const res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/advance_payment_request/get-percentage/${purchaseOrder.po_no}`,
      );
      if (res.success) {
        const po_total =
          purchaseOrder?.subtotal +
            purchaseOrder?.cgst +
            purchaseOrder?.sgst +
            purchaseOrder?.igst || 0;
        const calculatedPercentage = (res.totalAmount / (po_total || 1)) * 100;
        // const totalPercentageUsed = res.totalPercentage - calculatedPercentage || 0; // Backend response
        const availablePercentage = 100 - calculatedPercentage;
        setPercent(availablePercentage);
        if (percentage > availablePercentage) {
          showToast({
            type: ToastType.error,
            text: `Percentage exceeds available limit. Available: ${availablePercentage}%`,
          });
          return;
        }
        // const availablePercent = 100 - totalPercentageUsed;
        const calculatedAmount = (percentage * po_total) / 100;

        if (calculatedAmount > po_total) {
          showToast({
            type: ToastType.error,
            text: "Amount should not be greater than total amount.",
          });
          return;
        }

        // Update the payment amount in the state
        setPaymentRequest((prev) => ({
          ...prev,
          // percentage:availablePercent,
          payment_amount: calculatedAmount,
        }));
      } else {
        showToast({
          type: ToastType.error,
          text: res.message || "Failed to fetch percentage data.",
        });
      }
    } catch (error: any) {
      console.error("Error fetching percentage:", error);
      showToast({
        type: ToastType.error,
        text: error.message || "An unexpected error occurred.",
      });
    }
  }, 0);

  const handleAmountChange = throttle((e: any) => {
    const amount = Number(e.target.value);

    // Update state immediately for responsive input
    setPaymentRequest((prev) => ({
      ...prev,
      payment_amount: amount,
      percentage: 0,
    }));

    // Trigger validation and API logic
    getPercentage(amount);
  }, 0);

  const getPercentage = throttle(async (amount: number) => {
    if (amount < 0) {
      showToast({
        type: ToastType.error,
        text: "Amount cannot be negative.",
      });
      return;
    }

    try {
      const res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/advance_payment_request/get-percentage/${purchaseOrder.po_no}`,
      );
      if (res.success) {
        const po_total =
          purchaseOrder?.subtotal +
            purchaseOrder?.cgst +
            purchaseOrder?.sgst +
            purchaseOrder?.igst || 0;
        const totalAmount = res.totalAmount || 0;

        const availableAmount = po_total - totalAmount;
        setAmount(availableAmount);

        if (amount > availableAmount) {
          showToast({
            type: ToastType.error,
            text: `Amount exceeds available limit. Available: ${availableAmount}.`,
          });
          return;
        }
        const calculatedPercentage = purchaseOrder
          ? (amount / (po_total || 1)) * 100
          : 0;
        // const calculatedPercentage = (amount / (data.total - data.paid)) * 100;
        if (calculatedPercentage > 100) {
          showToast({
            type: ToastType.error,
            text: "Calculated percentage exceeds 100%.",
          });
          return;
        }

        setPaymentRequest((prev) => ({
          ...prev,
          percentage: calculatedPercentage,
        }));
      } else {
        showToast({
          type: ToastType.error,
          text: res.message || "Failed to fetch amount data.",
        });
      }
    } catch (error: any) {
      console.error("Error fetching amount:", error);
      showToast({
        type: ToastType.error,
        text: error.message || "An unexpected error occurred.",
      });
    }
  }, 0);

  const uploadFile = async ({
    file,
    category,
    removeSelectedFile,
    setShowUpload,
  }: {
    file: File;
    category: string;
    removeSelectedFile: () => void;
    setShowUpload: (v: boolean) => void;
  }) => {
    try {
      if (!file || !category) {
        showToast({
          type: ToastType.warning,
          text: "Please select file and category",
        });
        return;
      }
      setLoading(true);
      const { name, type } = file;

      const create_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${purchaseOrder.id}/attachment`;
      const get_signed_urls = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/signed-url`;
      const query = {
        mimetype: type,
        extension: name.split(".").pop(),
        dir: file_dir.pocuremnt_attachments,
      };

      // 1. Get signed URL
      const res = await fetchGet(get_signed_urls + toQueryString(query));
      if (res.success) {
        const { signed_url, url } = res.data;
        let headers = getHeaders(false);
        headers["Content-Type"] = type;

        // 2. Upload to S3
        const aws_res = await axios.put(signed_url, file, { headers });

        if (aws_res.status === 200) {
          // 3. Save attachment in backend
          const attachment: AttachmentModel = {
            id: generate_id(),
            category,
            type,
            url,
          };

          const create_res = await fetchPost(create_url, attachment);

          if (create_res.success) {
            const uploadedAttachment = create_res.data; // backend returns attachment in `data`

            showToast({
              type: ToastType.success,
              text: create_res.message,
            });

            setPurchaseOrder((o) => ({
              ...o,
              attachments: [...(o.attachments || []), uploadedAttachment],
            }));

            // 4. Send to Tyno if Tax Invoice
            if (
              uploadedAttachment?.category &&
              uploadedAttachment.category.toLowerCase().trim() ===
                "tax invoice" &&
              purchaseOrder.approval_status === "Approved"
            ) {
              try {
                const tynoRes = await sendToTyno(
                  purchaseOrder.po_no,
                  purchaseOrder.id,
                  uploadedAttachment,
                );

                if (tynoRes.success) {
                  showToast({
                    type: ToastType.success,
                    text: tynoRes.message,
                  });
                } else {
                  showToast({
                    type: ToastType.error,
                    text:
                      "Upload succeeded but not sent to Tyno: " +
                      tynoRes?.error,
                  });
                }
              } catch (err: any) {
                showToast({
                  type: ToastType.error,
                  text: "Error sending to Tyno: " + err.message,
                });
              }
            }

            removeSelectedFile();
            setShowUpload(false);
            setAttachmentKey(Math.random() * 1000);
          } else {
            showToast({
              type: ToastType.error,
              text: "Failed to save attachment",
            });
          }
        } else {
          showToast({
            type: ToastType.error,
            text: "File Upload failed",
          });
        }
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteFile = async (att: AttachmentModel) => {
    try {
      if (!window.confirm("Are your sure to delete ?")) return;
      if (!att) {
        showToast({
          type: ToastType.warning,
          text: "Please select file",
        });
        return;
      }
      setLoading(true);
      const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${purchaseOrder.id}/attachment/${att.id}`;

      const res = await fetchDelete(url);

      if (res.success) {
        showToast({
          type: ToastType.success,
          text: res.message,
        });
        setPurchaseOrder((o) => ({
          ...o,
          attachments: [
            ...(o.attachments || []).filter((f) => f.id !== att.id),
          ],
        }));
        setAttachmentKey(Math.random() * 1000);
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };

  const onSelectAttchment = (d: AttachmentModel) => {
    window.open(d.url, "_blank");
  };

  useEffect(() => {
    if (purchaseOrder.vendor_currency) {
      getCurrencyExchangeRate();
    }
  }, [purchaseOrder.vendor_currency]);

  useEffect(() => {
    if (purchaseOrder.id && !project && purchaseOrder.project_id) {
      getProjectData(purchaseOrder.project_id);
    }
  }, [purchaseOrder]);

  const getProjectData = async (id: string) => {
    setLoading(true);

    // Project Master (new) first, then legacy procurement projects for older POs
    let res = await fetchGet(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/project/${id}`,
    );
    if (!res.success) {
      res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/project/${id}`,
      );
    }
    if (res.success) {
      setProject({ ...res.data });
    } else showToast({ type: ToastType.error, text: res.error });
    setLoading(false);
  };

  const fetchLinkedPRData = async (prop: {
    search?: string;
    page: number;
    count: number;
    all?: boolean;
    filterData?: {
      poNo?: string;
      pr_id?: string;
      pi_no_Or_Inv_no?: string;
      created_by_name?: string[];
      emp_names?: string;
      type?: string[];
      payment_mode?: string[];
      due_date?: Date;
      created_date?: Date;
      pr_status?: string[];
      payment_status?: string[];
    };
  }) => {
    setLoading(true);
    try {
      if (prop.filterData) {
        prop.filterData.poNo = purchaseOrder.po_no;
      }
      const res = await getPaymentList(prop);
      if (res.success) {
        setPaymentRequestList(res.data.data);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error?.message || error.toString(),
      });
    } finally {
      setLoading(false); // End loading state
    }
  };
  const fetchLinkedInwardData = async (prop: any) => {
    setLoading(true);

    try {
      const res = await GetPurchaseVoucherList(prop);
      if (res.success) {
        setInwardList(res.data.data);
        if (res.data.metadata) {
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const handleResolveDispute = async () => {
    try {
      setLoading(true);
      const res = await UpdateDisputeStatusByPONoApi({
        po_no: purchaseOrder.po_no,
        version: purchaseOrder.version ?? "",
        status: "resolved",
        reason: resolveRemark,
      });
      if (res.success) {
        showToast({
          type: ToastType.success,
          text: "Dispute resolved successfully",
        });
        getData(id);
      } else {
        showToast({
          type: ToastType.error,
          text: res.error || "Failed to resolve dispute",
        });
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
    } finally {
      setLoading(false);
      setShowResolveDisputeModal(false);
      setResolveRemark("");
    }
  };

  const fetchLinkedInwardsAndPRData = async () => {
    if (purchaseOrder.po_no) {
      let purchase_order_prop = {
        page: 1,
        count: 0,
        all: true,
        filterData: {
          poNo: purchaseOrder.po_no,
        },
      };
      fetchLinkedPRData(purchase_order_prop);

      let inward_prop = {
        page: 1,
        count: 0,
        all: true,
        po_number: purchaseOrder.po_no,
      };

      fetchLinkedInwardData(inward_prop);
    }
  };

  useEffect(() => {
    fetchLinkedInwardsAndPRData();
  }, [purchaseOrder.po_no]);

  return (
    <>
      {showCreatePaymentRequestModal && (
        <DrawerModal
          id="po_detail_create_payment_request_drawer"
          show={showCreatePaymentRequestModal}
          title={"Create Payment Request"}
          onClose={resetForm}
          location={DrawerModalLoaction.right} // or whatever location you are using for the DrawerModal
        >
          <div className="flex flex-col gap-3 w-auto h-auto p-5 text-xs md:text-sm">
            {/* Tabs to select payment type */}
            <div className="flex gap-4 mb-4">
              <button
                id="po_detail_payment_request_tab_advance"
                onClick={() => setPaymentRequestType("advance")}
                className={`${
                  paymentRequestType === "advance"
                    ? "bg-myPrimaryColor text-white"
                    : "bg-gray-100"
                } px-4 py-2 rounded-md`}
              >
                Advance Payment
              </button>
              <button
                id="po_detail_payment_request_tab_invoice"
                onClick={() => setPaymentRequestType("invoice")}
                className={`${
                  paymentRequestType === "invoice"
                    ? "bg-myPrimaryColor text-white"
                    : "bg-gray-100"
                } px-4 py-2 rounded-md`}
              >
                Against Invoice
              </button>
            </div>

            {/* Render form based on selected payment type */}
            {paymentRequestType === "advance" && (
              <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-5 w-auto">
                  {/* First Row */}
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Percentage
                      </label>
                      <input
                        id="po_detail_payment_request_percentage"
                        type="number"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.percentage || ""}
                        onChange={handlePercentageChange}
                      />
                      <span className="font-light">
                        Available Percent is:{percent}
                      </span>
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Payment Amount *
                      </label>
                      <input
                        id="po_detail_payment_request_advance_amount"
                        type="number"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.payment_amount || ""}
                        onChange={handleAmountChange}
                      />
                      <span className="font-light">
                        Available amount is:{amount}
                      </span>
                    </div>
                  </div>
                  {/* Second Row */}
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Due Date
                      </label>
                      <input
                        id="po_detail_payment_request_due_date"
                        type="date"
                        required
                        value={
                          paymentRequest?.due_date
                            ? moment(paymentRequest?.due_date).format(
                                "YYYY-MM-DD",
                              ) // Format to YYYY-MM-DD for input
                            : "" // Empty by default, so no date is selected initially
                        }
                        min={moment().format("YYYY-MM-DD")} // Prevent selection of past dates
                        className="w-full px-2 py-1 border rounded-md"
                        onChange={(e) => {
                          const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                          const date = selectedDate
                            ? new Date(
                                new Date(selectedDate).setHours(0, 0, 0, 0),
                              ) // Set the time to 00:00:00
                            : undefined; // If no date is selected, reset the value

                          // Update the state with the selected date
                          setPaymentRequest((pv) => ({
                            ...pv,
                            due_date: date!, // Save the selected date in state
                          }));
                        }}
                      />
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        PI Number
                      </label>
                      <input
                        id="po_detail_payment_request_pi_no"
                        type="text"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.pi_no}
                        onChange={(e) =>
                          setPaymentRequest({
                            ...paymentRequest,
                            pi_no: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  {/* Third Row */}
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        PI Date
                      </label>
                      <input
                        id="po_detail_payment_request_pi_date"
                        type="date"
                        className="border px-2 py-1 rounded-md w-full"
                        value={
                          paymentRequest?.pi_date
                            ? moment(paymentRequest?.pi_date).format(
                                "YYYY-MM-DD",
                              )
                            : ""
                        }
                        onChange={(e) => {
                          const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                          const date = selectedDate
                            ? new Date(
                                new Date(selectedDate).setHours(0, 0, 0, 0),
                              ) // Convert to a date object
                            : undefined; // Reset if no date is selected

                          // Update the paymentRequest state with the selected date
                          setPaymentRequest((pv) => ({
                            ...pv,
                            pi_date: date!, // Save the selected date in state
                          }));
                        }}
                      />
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        PI Amount
                      </label>
                      <input
                        id="po_detail_payment_request_pi_amount"
                        type="number"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.pi_amount}
                        onChange={(e) =>
                          setPaymentRequest({
                            ...paymentRequest,
                            pi_amount: +e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-1 w-full">
                  <label htmlFor="" className="text-xs text-gray-500">
                    Payment Mode
                  </label>
                  <select
                    id="po_detail_payment_request_payment_mode"
                    className="border px-2 py-1 rounded-md w-full"
                    value={paymentRequest.payment_mode} // Ensure default is "raw_material"
                    onChange={(e) =>
                      setPaymentRequest({
                        ...paymentRequest,
                        payment_mode: e.target.value,
                      })
                    }
                  >
                    <option value="" hidden>
                      Select
                    </option>
                    {Object.values(PaymentModeOptions).map((c, i) => (
                      <option value={c} key={i}>
                        {c}
                      </option>
                    ))}
                    {/* Add more options as needed */}
                  </select>
                </div>

                {/* Attach Files Section */}

                <div className="flex flex-col gap-1">
                  <label htmlFor="" className="text-xs text-gray-500">
                    Attach Files
                  </label>

                  <input
                    id="po_detail_payment_request_advance_files_input"
                    type="file"
                    multiple
                    className="border px-2 py-1 rounded-md"
                    // onChange={handleFileChange} // Handle file selection
                    onChange={(e) => {
                      if (e.target.files) {
                        const newFiles = Array.from(e.target.files);
                        setAdvancePaymentFileList((prevFiles) => [
                          ...prevFiles,
                          ...newFiles,
                        ]);
                      }
                    }}
                  />
                  <div className="w-full mt-2 mx-auto">
                    {advancePaymentFileList.length > 0 &&
                      advancePaymentFileList.map(
                        (file: File, index: number) => (
                          <ul className="py-2 m-2 flex justify-around rounded-md text-black border-2">
                            <div className="">
                              <li
                                key={index}
                                className="flex items-center gap-2"
                              >
                                {file ? (
                                  // Check if the file has a URL (for image/PDF preview)
                                  file.type === "image" ? (
                                    <img
                                      src={file.name}
                                      alt={file.name}
                                      className="w-16 h-16 object-cover"
                                    />
                                  ) : file.type === "pdf" ? (
                                    <embed
                                      src={file.name}
                                      type="application/pdf"
                                      className="w-16 h-16"
                                    />
                                  ) : (
                                    <span>{file.name}</span> // For other file types, display file name
                                  )
                                ) : (
                                  // If file doesn't have a URL, just display file name
                                  <span>{"No file selected"}</span>
                                )}
                              </li>
                            </div>
                            <div>
                              <button
                                id={`po_detail_payment_request_advance_file_${index}_remove_btn`}
                                type="button"
                                className="text-red-500"
                                onClick={() => {
                                  setAdvancePaymentFileList((prevFiles) =>
                                    prevFiles.filter(
                                      (_, currIndex) => currIndex !== index,
                                    ),
                                  );
                                }} // Remove the attachment
                              >
                                Remove
                              </button>
                            </div>
                          </ul>
                        ),
                      )}
                  </div>
                </div>

                {/* Additional Notes Text Area */}
                <div className="flex flex-col gap-1">
                  <label htmlFor="" className="text-xs text-gray-500">
                    Additional Notes
                  </label>
                  <textarea
                    id="po_detail_payment_request_advance_notes"
                    className="border px-2 py-1 rounded-md"
                    value={paymentRequest.notes}
                    onChange={(e) =>
                      setPaymentRequest({
                        ...paymentRequest,
                        notes: e.target.value,
                      })
                    }
                    placeholder="Enter any additional notes here"
                  />
                </div>
                <div className="flex flex-row gap-4 justify-between my-5">
                  <div className="align-center justify-center flex">
                    <button
                      id="po_detail_payment_request_advance_cancel_btn"
                      onClick={() => {
                        handleCancelPaymentRequest();
                      }}
                      className="bg-white px-4 py-1 text-xs md:px-8 md:py-2 md:text-sm rounded-md text-black ml-auto border-2"
                    >
                      Cancel
                    </button>
                  </div>
                  <div>
                    <button
                      id="po_detail_payment_request_advance_submit_btn"
                      disabled={isSubmitting}
                      onClick={handleCreatePaymentRequest}
                      className="bg-myPrimaryColor px-4 py-1 text-xs md:px-8 md:py-2 md:text-sm rounded-md text-white ml-auto border-2"
                    >
                      {isSubmitting ? "Creating..." : "Create"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {paymentRequestType === "invoice" && (
              <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-5 w-auto">
                  {/* First Row */}
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Invoice Number *
                      </label>
                      <input
                        id="po_detail_payment_request_invoice_no"
                        type="text"
                        className="border px-2 py-1 rounded-md"
                        value={paymentRequest.invoice_no}
                        onChange={(e) =>
                          setPaymentRequest({
                            ...paymentRequest,
                            invoice_no: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Invoice Date *
                      </label>
                      <input
                        id="po_detail_payment_request_invoice_date"
                        type="date"
                        className="border px-2 py-1 rounded-md w-full"
                        value={
                          paymentRequest?.invoice_date
                            ? moment(paymentRequest?.invoice_date).format(
                                "YYYY-MM-DD",
                              )
                            : ""
                        }
                        onChange={(e) => {
                          const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                          const date = selectedDate
                            ? new Date(
                                new Date(selectedDate).setHours(0, 0, 0, 0),
                              ) // Convert to a date object
                            : undefined; // Reset if no date is selected

                          // Update the paymentRequest state with the selected date
                          setPaymentRequest((pv) => ({
                            ...pv,
                            invoice_date: date!, // Save the selected date in state
                          }));
                        }}
                      />
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Invoice Amount *
                      </label>

                      <input
                        id="po_detail_payment_request_invoice_amount"
                        type="number"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.invoice_amount || ""}
                        onChange={handleInvoiceAmount}
                      />
                      <span className="font-light">
                        Available amount is:{invoiceAmount}
                      </span>
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Payment Amount *
                      </label>
                      <input
                        id="po_detail_payment_request_invoice_payment_amount"
                        type="number"
                        placeholder="INR 0"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.payment_amount || ""}
                        onChange={handlePaymentAmount}
                        // onChange={(e) =>
                        //   setPaymentRequestAgainstInvoice({
                        //     ...paymentRequestAgainstInvoice,
                        //     payment_amount: +e.target.value,
                        //   })
                        // }
                      />
                    </div>
                  </div>

                  {/* Third Row */}
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Category of Expense
                      </label>
                      <select
                        id="po_detail_payment_request_category_of_expense"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.category_of_expence} // Ensure default is "raw_material"
                        onChange={(e) =>
                          setPaymentRequest({
                            ...paymentRequest,
                            category_of_expence: e.target.value,
                          })
                        }
                      >
                        <option value="" hidden>
                          Select
                        </option>
                        {Object.values(CategoryOfExpenseOptions).map((c, i) => (
                          <option value={c} key={i}>
                            {c}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        No. of Installations
                      </label>
                      <input
                        id="po_detail_payment_request_no_of_installations"
                        type="number"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.no_of_intallations}
                        onChange={(e) =>
                          setPaymentRequest({
                            ...paymentRequest,
                            no_of_intallations: +e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row gap-5 w-full">
                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Due Date
                      </label>
                      <input
                        type="date"
                        name=""
                        id="po_detail_payment_request_invoice_due_date"
                        value={
                          paymentRequest?.due_date
                            ? moment(paymentRequest?.due_date).format(
                                "YYYY-MM-DD",
                              )
                            : ""
                        }
                        min={moment().format("YYYY-MM-DD")} // Prevent selection of past dates
                        className="w-full px-2 py-1 border rounded-md"
                        onChange={(e) => {
                          const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                          const date = selectedDate
                            ? new Date(
                                new Date(selectedDate).setHours(0, 0, 0, 0),
                              ) // Convert to a date object
                            : undefined; // Reset if no date is selected

                          // Update the paymentRequest state with the selected date
                          setPaymentRequest((pv) => ({
                            ...pv,
                            due_date: date!, // Save the selected date in state
                          }));
                        }}
                      />
                    </div>

                    <div className="flex flex-col gap-1 w-full">
                      <label htmlFor="" className="text-xs text-gray-500">
                        Payment Mode
                      </label>
                      <select
                        id="po_detail_payment_request_invoice_payment_mode"
                        className="border px-2 py-1 rounded-md w-full"
                        value={paymentRequest.payment_mode} // Ensure default is "raw_material"
                        onChange={(e) =>
                          setPaymentRequest({
                            ...paymentRequest,
                            payment_mode: e.target.value,
                          })
                        }
                      >
                        <option value="" hidden>
                          Select
                        </option>
                        {Object.values(PaymentModeOptions).map((c, i) => (
                          <option value={c} key={i}>
                            {c}
                          </option>
                        ))}
                        {/* Add more options as needed */}
                      </select>
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      Customer Location
                    </label>
                    <input
                      id="po_detail_payment_request_customer_location"
                      type="text"
                      placeholder="Write address here.."
                      className="border px-2 py-1 rounded-md w-full"
                      value={paymentRequest.customer_location}
                      onChange={(e) =>
                        setPaymentRequest({
                          ...paymentRequest,
                          customer_location: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* Attach Files Section */}
                <div className="flex flex-col gap-1">
                  <label htmlFor="" className="text-xs text-gray-500">
                    Attach Files *
                  </label>
                  <input
                    id="po_detail_payment_request_invoice_files_input"
                    type="file"
                    multiple
                    className="border px-2 py-1 rounded-md"
                    onChange={(e) => {
                      if (e.target.files) {
                        const newFiles = Array.from(e.target.files);
                        setAgainstInvoiceFileList((prevFiles) => [
                          ...prevFiles,
                          ...newFiles,
                        ]);
                      }
                    }}
                  />
                  {/* Display attached files */}
                  <div className="w-full mt-2 mx-auto">
                    {againstInvoiceFileList.length > 0 &&
                      againstInvoiceFileList.map(
                        (file: File, index: number) => (
                          <ul className="py-2 flex justify-around rounded-md text-black border-2">
                            <div className="">
                              <li
                                key={index}
                                className="flex items-center gap-2"
                              >
                                {file ? (
                                  // Check if the file has a URL (for image/PDF preview)
                                  file.type === "image" ? (
                                    <img
                                      src={file.name}
                                      alt={file.name}
                                      className="w-16 h-16 object-cover"
                                    />
                                  ) : file.type === "pdf" ? (
                                    <embed
                                      src={file.name}
                                      type="application/pdf"
                                      className="w-16 h-16"
                                    />
                                  ) : (
                                    <span>{file.name}</span> // For other file types, display file name
                                  )
                                ) : (
                                  // If file doesn't have a URL, just display file name
                                  <span>{"No file selected"}</span>
                                )}
                              </li>
                            </div>
                            <div>
                              <button
                                id={`po_detail_payment_request_invoice_file_${index}_remove_btn`}
                                type="button"
                                className="text-red-500"
                                onClick={() => {
                                  setAgainstInvoiceFileList((prevFiles) =>
                                    prevFiles.filter(
                                      (_, currIndex) => currIndex !== index,
                                    ),
                                  );
                                }} // Remove the attachment
                              >
                                Remove
                              </button>
                            </div>
                          </ul>
                        ),
                      )}
                  </div>
                </div>

                {/* Additional Notes Text Area */}
                <div className="flex flex-col gap-1">
                  <label htmlFor="" className="text-xs text-gray-500">
                    Additional Notes
                  </label>
                  <textarea
                    id="po_detail_payment_request_invoice_notes"
                    className="border px-2 py-1 rounded-md"
                    value={paymentRequest.notes}
                    onChange={(e) =>
                      setPaymentRequest({
                        ...paymentRequest,
                        notes: e.target.value,
                      })
                    }
                    placeholder="Enter any additional notes here"
                  />
                </div>
                <div className="flex flex-row gap-4 justify-between my-5">
                  <div className="align-center justify-center flex">
                    <button
                      id="po_detail_payment_request_invoice_cancel_btn"
                      onClick={handleCancelPaymentRequest}
                      className="bg-white px-4 py-1 text-xs md:px-8 md:py-2 md:text-sm rounded-md text-black ml-auto border-2"
                    >
                      Cancel
                    </button>
                  </div>
                  <div>
                    <button
                      id="po_detail_payment_request_invoice_submit_btn"
                      disabled={isSubmitting}
                      onClick={handleCreatePaymentRequest}
                      className="bg-myPrimaryColor px-4 py-1 text-xs md:px-8 md:py-2 md:text-sm rounded-md text-white ml-auto border-2"
                    >
                      {isSubmitting ? "Creating..." : "Create"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </DrawerModal>
      )}
      {showHistory && (
        <DrawerModal
          id="po_detail_history_drawer"
          location={DrawerModalLoaction.right}
          show={showHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="History"
        >
          <ActionHistory po_no={showHistory} data={showHistory1} />
        </DrawerModal>
      )}
      {showSnaps && purchaseOrder.id && (
        <DrawerWidget
          id="po_detail_snaps_drawer"
          data={{
            id: 1,
            title: "Purchase order prints",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: <PoSnapSection po_no={purchaseOrder.po_no} />,
          }}
          onClose={function (): void {
            setShowSnaps(false);
          }}
        ></DrawerWidget>
      )}
      {showAttachment && purchaseOrder.id && (
        <DrawerWidget
          id="po_detail_attachments_drawer"
          data={{
            id: 1,
            title: "Attachments",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: (
              <AttachmentSectionV2
                key={attachmentKey}
                poNo={purchaseOrder}
                attachments={purchaseOrder.attachments}
                onSubmit={uploadFile}
                onDelete={deleteFile}
                onSelect={onSelectAttchment}
              />
            ),
          }}
          onClose={function (): void {
            setShowAttachment(false);
          }}
        ></DrawerWidget>
      )}

      <div className="mobile-shrink relative bg-myBgcolor h-screen px-2 md:px-5 space-y-4 overflow-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between py-2 md:sticky md:top-0 bg-myBgcolor gap-2 z-20">
          <div className="flex flex-row items-center">
            <button
              id="po_detail_back_btn"
              className="flex items-center p-2 hover:text-gray-700 font-bold text-lg"
              onClick={() => {
                history.goBack();
              }}
            >
              <Icon path={mdiChevronLeft} className="h-6 w-6 font-bold"></Icon>
              <span className="hidden md:inline">Back</span>
            </button>
            <div className="text-xl font-bold border-l-4 border-myPrimaryColor p-2">
              Purchase Order{" "}
              <span className="text-sm">#{purchaseOrder.po_no}</span>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-2">
            <div className="flex gap-2 items-center">
              <label htmlFor="" className="text-sm font-semibold text-gray-500">
                Date
              </label>
              <input
                id="po_detail_date"
                type="date"
                disabled={true}
                className="focus:outline-none focus:ring-2 ring-blue-400 rounded-md py-1 px-2 w-full text-sm border"
                value={
                  purchaseOrder.date
                    ? moment(purchaseOrder.date).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  const date = UTCToLocalDate(e.target.value);
                  if (date) {
                    setPurchaseOrder((prev: PurchaseOrderModelV2) => ({
                      ...prev,
                      date,
                    }));
                  }
                }}
              />
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {!showDisputeActionsOnly && !procuremntRead && (
                <>
                  {purchaseOrder.po_no &&
                    purchaseOrder.approval_level ===
                      purchaseOrder.current_approval_level &&
                    (purchaseOrder.current_approval_count ?? 0) >=
                      (purchaseOrder.current_approval_required_count ?? 0) && (
                      <button
                        id="po_detail_create_payment_request_btn"
                        className="bg-myPrimaryColor px-3 py-1 text-sm rounded-md text-white"
                        onClick={() => {
                          setShowCreatePaymentRequestModal(true);
                        }}
                      >
                        Create Payment Request
                      </button>
                    )}
                </>
              )}

              {purchaseOrder.id &&
                !procuremntRead &&
                !isWarehouseOperator &&
                !(
                  (purchaseOrder.total_po_qty ?? 0) > 0 &&
                  (purchaseOrder.total_received_qty ?? 0) >=
                    (purchaseOrder.total_po_qty ?? 0)
                ) &&
                (!((purchaseOrder.total_received_qty ?? 0) > 0) ||
                  canUpdatePartialPO) && (
                  <button
                    id="po_detail_update_btn"
                    className="bg-myPrimaryColor px-1 py-1 text-sm rounded-md text-white"
                    onClick={() => {
                      navigation.push(`${urls.purchase_order}/update/${id}`);
                    }}
                  >
                    Update
                  </button>
                )}

              {showDisputeActionsOnly && (
                <button
                  id="po_detail_resolve_dispute_btn"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 text-sm rounded-md shadow-md flex items-center gap-2 transition-all active:scale-95 border border-blue-600 border-opacity-30 font-semibold"
                  onClick={() => setShowResolveDisputeModal(true)}
                >
                  <Icon path={mdiCheckCircleOutline} size={0.7} />
                  Resolve Dispute
                </button>
              )}
              {showDisputeActionsOnly && (
                <button
                  id="po_detail_revise_po_btn"
                  className="bg-myPrimaryColor px-3 py-1 text-sm rounded-md text-white"
                  onClick={() => {
                    navigation.push(
                      `${urls.purchase_order}/revised/create/${id}`,
                    );
                  }}
                >
                  Revise PO
                </button>
              )}

              {purchaseOrder.id && !showDisputeActionsOnly && (
                <button
                  id="po_detail_history_btn"
                  title="Logs"
                  onClick={() => {
                    setShowHistory(purchaseOrder.po_no);
                  }}
                  className="rounded-full p-1 md:p-2 hover:scale-105 transform duration-150 bg-myPrimaryColor text-white shadow cursor-pointer flex items-center justify-center"
                >
                  <Icon
                    path={mdiHistory}
                    className="h-4 md:h-6 w-4 md:w-6"
                  ></Icon>
                </button>
              )}
            </div>
          </div>
        </div>

        {purchaseOrder.approval_status === po_approval_status.rejected &&
          purchaseOrder.commets.length > 0 && (
            <p>
              <b>Reason of rejection :</b>
              {purchaseOrder.commets[purchaseOrder.commets.length - 1].comment}
            </p>
          )}

        <div className="bg-white rounded-lg p-3">
          <span className="text-gray-400 text-xs">PO Type</span>
          <div className="font-bold">{purchaseOrder.type ?? "--"}</div>
          {purchaseOrder.type === POType["Job Work PO"] && (
            <>
              <p className="text-xs font-semibold tracking-widest text-blue-700 mb-2">
                Job Work PO mode active: Split totals for Inventory and Payable
                Services. Only Service lines will attract GST.
              </p>
            </>
          )}
        </div>
        <div className="bg-white rounded-lg p-3">
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <div className="col-span-2">
              <ReadField label="Vendor" value={purchaseOrder.party?.name} />
            </div>
            <ReadField
              label="Vendor Registered Office"
              value={purchaseOrder.party.mail_detail.address.line1}
            />
            <ReadField
              label="Line 2"
              value={purchaseOrder.party.mail_detail.address.line2}
            />
            <ReadField
              label="Country"
              value={purchaseOrder.party.mail_detail.address.country}
            />
            <ReadField
              label="State"
              value={purchaseOrder.party.mail_detail.address.state}
            />
            <ReadField
              label="City"
              value={purchaseOrder.party.mail_detail.address.city}
            />
            <ReadField
              label="Pincode"
              value={purchaseOrder.party.mail_detail.address.pincode}
            />
            <ReadField
              label="GST Reg"
              value={purchaseOrder.party.tax_detail.reg_type}
            />
            <ReadField
              label="GST No"
              value={purchaseOrder.party.tax_detail.gst_no[0]}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="bg-white rounded-lg p-3">
            <h1 className="font-semibold mb-2">Bill To</h1>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              <ReadField
                label="Name"
                value={purchaseOrder.bill_to?.name}
                className="col-span-2"
              />
              <ReadField
                label="GST No"
                value={purchaseOrder.bill_to?.gst_number}
                className="col-span-2"
              />
              <ReadField
                label="Address"
                value={purchaseOrder.bill_to?.address.line1}
              />
              <ReadField
                label="Line 2"
                value={purchaseOrder.bill_to?.address.line2}
              />
              <ReadField
                label="Country"
                value={purchaseOrder.bill_to?.address.country}
              />
              <ReadField
                label="State"
                value={purchaseOrder.bill_to?.address.state}
              />
              <ReadField
                label="City"
                value={purchaseOrder.bill_to?.address.city}
              />
              <ReadField
                label="Pincode"
                value={purchaseOrder.bill_to?.address.pincode}
              />
            </div>
          </div>
          <div className="bg-white rounded-lg p-3">
            <h1 className="font-semibold mb-2">Shipping Profile</h1>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              <ReadField
                label="Shipping profile"
                value={purchaseOrder.warehouse?.name}
                className="col-span-2"
              />
              <ReadField
                label="Address"
                value={purchaseOrder.shipping_profile.address.line1}
              />
              <ReadField
                label="Line 2"
                value={purchaseOrder.shipping_profile.address.line2}
              />
              <ReadField
                label="Country"
                value={purchaseOrder.shipping_profile.address.country}
              />
              <ReadField
                label="State"
                value={purchaseOrder.shipping_profile.address.state}
              />
              <ReadField
                label="City"
                value={purchaseOrder.shipping_profile.address.city}
              />
              <ReadField
                label="Pincode"
                value={purchaseOrder.shipping_profile.address.pincode}
              />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg p-3 w-full sm:w-1/2 md:w-1/3">
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <ReadField
              label="Currency"
              value={
                purchaseOrder.vendor_currency
                  ? `${purchaseOrder.vendor_currency.formal_name} (${purchaseOrder.vendor_currency.symbol})`
                  : undefined
              }
            />
            <ReadField
              label={"Exchange rate (\u20b9)"}
              value={purchaseOrder.vendor_currency_to_inr}
            />
          </div>
          <div className="flex gap-1 text-gray-500 text-xs mt-2 items-center">
            <Icon path={mdiInformationOutline} size={0.8}></Icon>
            INR Per {purchaseOrder.vendor_currency.short_name} Eg: INR 70 = USD
            1 then enter 70
          </div>
        </div>
        <div className="my-5">
          <h3 className="text-sm font-bold">Items</h3>
          {(() => {
            const isJobWork = purchaseOrder?.type === POType["Job Work PO"];
            return (
              <div className="mt-2 flex flex-col gap-3">
                {purchaseOrder.items.map((item, index) => (
                  <POLineItemCard
                    key={item.id}
                    variant={isJobWork ? "jobwork" : "regular"}
                    mode="view"
                    currency={purchaseOrder.vendor_currency}
                    data={item}
                    existingItems={existingItems}
                    onDelete={(d) => {
                      setPurchaseOrder((o) => ({
                        ...o,
                        items: o.items.filter((i) => i.id !== d.id),
                      }));
                    }}
                    onSubmit={(data: PoItemV2) => {
                      setPurchaseOrder((o) => ({
                        ...o,
                        items: o.items.map((it) =>
                          it.id === data.id ? data : it,
                        ),
                      }));
                    }}
                  />
                ))}
              </div>
            );
          })()}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:divide-x-2  text-xs  bg-white rounded-lg p-3  ">
          <div className=" flex flex-col gap-1 md:pr-5 ">
            <div className="grid grid-cols-1  md:grid-cols-4   dark: items-center">
              <label htmlFor="po_detail_delivery_date">Delivery Date *</label>
              <input
                disabled
                value={
                  purchaseOrder.delivery_date
                    ? moment(purchaseOrder.delivery_date).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  setPurchaseOrder((o: any) => ({
                    ...o,
                    delivery_date: UTCToLocalDate(e.target.value)!,
                  }));
                }}
                type="date"
                name=""
                id="po_detail_delivery_date"
                className="p-1 focus:outline-none border rounded w-full  col-span-3"
              ></input>
            </div>
            <div className="grid grid-cols-1  md:grid-cols-4  items-start">
              <label htmlFor="po_detail_ship_term">Delivery terms</label>
              <textarea
                disabled
                rows={3}
                value={purchaseOrder.ship_term}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/[\n\r]/g, ""); // Remove newlines
                  setPurchaseOrder((o: any) => ({
                    ...o,
                    ship_term: sanitizedValue,
                  }));
                }}
                name=""
                id="po_detail_ship_term"
                className="p-1 focus:outline-none border rounded w-full  col-span-3"
              ></textarea>
            </div>
            <div className="grid grid-cols-1  md:grid-cols-4  items-start">
              <label htmlFor="po_detail_payment_term">Payment terms</label>
              <textarea
                disabled
                rows={3}
                value={purchaseOrder.payment_term}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/[\n\r]/g, ""); // Remove newlines
                  setPurchaseOrder((o: any) => ({
                    ...o,
                    payment_term: sanitizedValue,
                  }));
                }}
                name=""
                id="po_detail_payment_term"
                className="p-1 focus:outline-none border rounded w-full  col-span-3"
              ></textarea>
            </div>
          </div>

          {purchaseOrder?.type === POType["Job Work PO"] ? (
            <div className="flex flex-row">
              <div className="border border-blue-200 bg-blue-50 rounded-lg p-5 flex justify-between items-start">
                <div>
                  <h3 className="text-sm font-semibold tracking-widest text-blue-700 mb-2">
                    INVENTORY SUMMARY (NON-PAYABLE)
                  </h3>

                  <div className="text-sm font-medium text-blue-900">
                    Inventory Value: {}
                  </div>

                  <p className="mt-1 text-sm italic text-blue-700">
                    Recorded only for inventory valuation. Not subject to GST.
                  </p>
                </div>

                <div className="text-2xl font-bold text-blue-900">
                  ₹{inventoryValue.toLocaleString()}
                </div>
              </div>

              <div className=" flex flex-col gap-1 md:pl-5 ">
                <div className="flex justify-between">
                  <h3 className="text-sm font-semibold tracking-widest text-blue-700 mb-2">
                    Payable Summary (Job Work Service)
                  </h3>
                </div>{" "}
                <div className="flex justify-between ">
                  <div className="">Service Subtotal</div>
                  <div className="">
                    {currencyFormat(
                      purchaseOrder.subtotal,
                      purchaseOrder.vendor_currency.short_name,
                    )}
                  </div>
                </div>
                <div className="flex justify-between ">
                  <div className="flex  gap-2 items-end ">
                    <label htmlFor="tax_desc">CGST </label>{" "}
                  </div>

                  <div className="">
                    +{" "}
                    {currencyFormat(
                      purchaseOrder.cgst,
                      purchaseOrder.vendor_currency.short_name,
                    )}
                  </div>
                </div>
                <div className="flex justify-between ">
                  <div className="flex  gap-2 items-end ">
                    <label htmlFor="tax_desc">SGST </label>{" "}
                  </div>

                  <div className="">
                    +{" "}
                    {currencyFormat(
                      purchaseOrder.sgst,
                      purchaseOrder.vendor_currency.short_name,
                    )}
                  </div>
                </div>
                <div className="flex justify-between ">
                  <div className="flex  gap-2 items-end ">
                    <label htmlFor="tax_desc">IGST</label>{" "}
                  </div>

                  <div className="">
                    +{" "}
                    {currencyFormat(
                      purchaseOrder.igst,
                      purchaseOrder.vendor_currency.short_name,
                    )}
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="">Paid</div>
                  <div className="">
                    {currencyFormat(
                      purchaseOrder.paid,
                      purchaseOrder.vendor_currency.short_name,
                    )}
                  </div>
                </div>
                <hr />
                <div className="flex justify-between font-bold ">
                  <p>Total</p>{" "}
                  <div className="">
                    {currencyFormat(
                      purchaseOrder.subtotal +
                        (purchaseOrder?.cgst +
                          purchaseOrder?.sgst +
                          purchaseOrder?.igst -
                          purchaseOrder?.paid),
                      purchaseOrder.vendor_currency.short_name,
                    )}
                  </div>
                </div>
                <hr />
                {purchaseOrder.vendor_currency.short_name !==
                  currencies.rupee.short_name && (
                  <div className="flex justify-between font-bold ">
                    <p>Total in INR</p>{" "}
                    <div className="">
                      {currencyFormat(
                        purchaseOrder.total *
                          purchaseOrder.vendor_currency_to_inr,
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className=" flex flex-col gap-1 md:pl-5 ">
              <div className="flex justify-between">
                <div className="">Subtotal</div>
                <div className="">
                  {currencyFormat(
                    purchaseOrder.subtotal,
                    purchaseOrder.vendor_currency.short_name,
                  )}
                </div>
              </div>{" "}
              <div className="flex justify-between ">
                <div className="flex  gap-2 items-end ">
                  <label htmlFor="tax_desc">CGST </label>{" "}
                </div>

                <div className="">
                  +{" "}
                  {currencyFormat(
                    purchaseOrder.cgst,
                    purchaseOrder.vendor_currency.short_name,
                  )}
                </div>
              </div>
              <div className="flex justify-between ">
                <div className="flex  gap-2 items-end ">
                  <label htmlFor="tax_desc">SGST </label>{" "}
                </div>

                <div className="">
                  +{" "}
                  {currencyFormat(
                    purchaseOrder.sgst,
                    purchaseOrder.vendor_currency.short_name,
                  )}
                </div>
              </div>
              <div className="flex justify-between ">
                <div className="flex  gap-2 items-end ">
                  <label htmlFor="tax_desc">IGST </label>{" "}
                </div>

                <div className="">
                  +{" "}
                  {currencyFormat(
                    purchaseOrder.igst,
                    purchaseOrder.vendor_currency.short_name,
                  )}
                </div>
              </div>
              <div className="flex justify-between">
                <div className="">Paid</div>
                <div className="">
                  {currencyFormat(
                    purchaseOrder.paid,
                    purchaseOrder.vendor_currency.short_name,
                  )}
                </div>
              </div>
              <hr />
              <div className="flex justify-between font-bold ">
                <p>Total</p>{" "}
                <div className="">
                  {currencyFormat(
                    purchaseOrder.subtotal +
                      (purchaseOrder?.cgst +
                        purchaseOrder?.sgst +
                        purchaseOrder?.igst -
                        purchaseOrder?.paid),
                    purchaseOrder.vendor_currency.short_name,
                  )}
                </div>
              </div>
              <hr />
              <hr />
              {purchaseOrder.vendor_currency.short_name !==
                currencies.rupee.short_name && (
                <div className="flex justify-between font-bold ">
                  <p>Total in INR</p>{" "}
                  <div className="">
                    {currencyFormat(
                      purchaseOrder.total *
                        purchaseOrder.vendor_currency_to_inr,
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="py-3">
          <div
            id="po_detail_linked_prs_toggle"
            className="cursor-pointer text-myPrimaryColor font-bold text-sm inline-flex items-center gap-1"
            onClick={() => setShowPRTable(showPRTable ? false : true)}
          >
            <Icon
              path={showPRTable ? mdiChevronDown : mdiChevronRight}
              className="h-4 w-4"
            />
            Expand to See Linked PRs
          </div>

          {showPRTable && (
            <section>
              <div className="mt-5 border rounded-lg p-3 shadow">
                <p className="font-semibold text-sm">Linked PRs</p>
                <NewTableView
                  stickyHeader={true}
                  show_index={true}
                  show_pagination={false}
                  headers={[
                    {
                      key: "pay_req_id",
                      value: "PR ID #",
                      type: FieldType.string,
                    },
                    {
                      key: "po_no",
                      value: "PO #",
                      type: FieldType.string,
                    },
                    {
                      key: "type",
                      value: "Type",
                      type: FieldType.string,
                    },
                    {
                      key: "po_date",
                      value: "PO Date",
                      type: FieldType.date,
                    },
                    {
                      key: "request_date",
                      value: "Created Date",
                      type: FieldType.date,
                    },
                    {
                      key: "created_by",
                      value: "Created By",
                      type: FieldType.string,
                    },
                    {
                      key: "vendor_name",
                      value: "Vendor",
                      type: FieldType.string,
                    },
                    {
                      key: "due_date",
                      value: "Due Date",
                      type: FieldType.date,
                    },
                    {
                      key: "payment_mode",
                      value: "Payment Mode",
                      type: FieldType.string,
                    },
                    {
                      key: "invoice_no",
                      value: "Invoice Number",
                      type: FieldType.string,
                    },
                    {
                      key: "invoice_date",
                      value: "Invoice Date",
                      type: FieldType.date,
                    },
                    {
                      key: "invoice_amount",
                      value: "Invoice Amount",
                      type: FieldType.currency,
                    },
                    {
                      key: "location",
                      value: "Customer Location",
                      type: FieldType.string,
                    },
                    {
                      key: "category_of_expense",
                      value: "Category of Expense",
                      type: FieldType.string,
                    },
                    {
                      key: "no_of_installations",
                      value: "No. of Installations",
                      type: FieldType.string,
                    },
                    {
                      key: "PI_no",
                      value: "PI NO",
                      type: FieldType.string,
                    },
                    {
                      key: "pi_date",
                      value: "PI Date",
                      type: FieldType.date,
                    },
                    {
                      key: "PI_amount",
                      value: "PI Amount",
                      type: FieldType.currency,
                    },
                    {
                      key: "amount",
                      value: "Payment Amount",
                      type: FieldType.currency,
                    },
                    {
                      key: "project_name",
                      value: "Project",
                      type: FieldType.string,
                    },
                    {
                      // colspan: 4,
                      key: "description",
                      value: "Note",
                      type: FieldType.long_string,
                    },
                    {
                      key: "po_approval_status",
                      value: "PO Approval",
                      type: FieldType.string,
                    },
                    {
                      key: "created_by",
                      value: "SPOC",
                      type: FieldType.string,
                    },
                    {
                      key: "utr",
                      value: "UTR",
                      type: FieldType.string,
                    },
                    {
                      key: "swift",
                      value: "Swift",
                      type: FieldType.string,
                    },
                    {
                      key: "tds_amount",
                      value: "TDS Amount",
                      type: FieldType.number,
                    },
                    {
                      key: "tds_percent",
                      value: "TDS Percent",
                      type: FieldType.number,
                    },
                    {
                      key: "paid_amount",
                      value: "Paid Amount",
                      type: FieldType.number,
                    },
                    {
                      key: "remarks",
                      value: "Remarks",
                      type: FieldType.string,
                    },
                    {
                      key: "status",
                      value: "Payment Status",
                      type: FieldType.string,
                    },
                    {
                      key: "pay_date",
                      value: "Payment Date",
                      type: FieldType.date,
                    },
                    {
                      key: "approved_at",
                      value: "Approved At",
                      type: FieldType.date,
                    },
                    {
                      key: "approved_by",
                      value: "Approved by",
                      type: FieldType.string,
                    },
                    {
                      key: "onhold_reason",
                      value: "OnHold Reason",
                      type: FieldType.string,
                    },
                    {
                      key: "reason",
                      value: "Reject Reason",
                      type: FieldType.string,
                    },
                    {
                      key: "pr_status",
                      value: "PR Status",
                      type: FieldType.string,
                    },
                  ]}
                  rows={paymentRequestList.map((data, i) => ({
                    data: {
                      ...data,
                      amount: data.payment_amount,
                      description: data.notes,
                      status: data.payment_status,
                    },
                    cells: [
                      {
                        builder: () => {
                          return data?.type === "ADVANCE" ? (
                            <a
                              href={`${urls.po_advance_payment_request}/updateAdvance/${data?.id}`}
                              className="text-blue-500 hover:text-blue-700"
                            >
                              {data.id}
                            </a>
                          ) : (
                            <a
                              href={`${urls.po_advance_payment_request}/updateInvoice/${data?.id}`}
                              className="text-blue-500 hover:text-blue-700"
                            >
                              {data?.id}
                            </a>
                          );
                        },
                      },
                      {
                        builder: () => (
                          <a
                            href={`${urls.purchase_order}/view-detail/${data?.po_id}`}
                            className="text-blue-500 hover:text-blue-700"
                          >
                            {data.po_no}
                          </a>
                        ),
                      },
                      { value: data.type },
                      { value: data.po_date },
                      { value: data.created_at },
                      { value: data.created_by_name },
                      { value: data.vendor },
                      { value: data?.due_date },
                      { value: data?.payment_mode },
                      { value: data?.invoice_no },
                      { value: data?.invoice_date },
                      { value: data?.invoice_amount },
                      { value: data?.customer_location },
                      { value: data?.category_of_expence },
                      { value: data?.no_of_intallations },
                      { value: data?.pi_no },
                      { value: data?.pi_date },
                      { value: data?.pi_amount },
                      { value: currencyFormat(data.payment_amount) },
                      { value: data.project },
                      { value: data.notes || "--" },
                      { value: data.po_approval },
                      { value: data.created_by_name },
                      { value: data?.utr },
                      { value: data?.swift },
                      { value: data?.tds_amount },
                      { value: data?.tds_percent },
                      { value: data?.amount_paid },
                      {
                        value: data?.paid_remarks ?? data?.failed_remarks ?? "",
                      },
                      { value: data.payment_status },
                      { value: data.payment_date },
                      { value: data.approved_at },
                      { value: data.approved_by_name },
                      { value: data.onhold_reason },
                      { value: data.reject_reason },
                      { value: data.pr_status },
                    ],
                  }))}
                  page={1}
                  total={0}
                  count={50}
                  itemCount={paymentRequestList.length}
                  onPageChange={() => {}}
                  onShowHistory={(data) => {}}
                />
              </div>
            </section>
          )}
        </div>
        <div className="py-3">
          <div
            id="po_detail_linked_inwards_toggle"
            className="cursor-pointer text-myPrimaryColor font-bold text-sm inline-flex items-center gap-1"
            onClick={() => setShowInwardTable(showInwardTable ? false : true)}
          >
            <Icon
              path={showInwardTable ? mdiChevronDown : mdiChevronRight}
              className="h-4 w-4"
            />
            Expand to See Linked Inwards
          </div>

          {showInwardTable && (
            <section>
              <div className="mt-5 border rounded-lg p-3 shadow">
                <p className="font-semibold text-sm">Linked Inwards</p>
                <NewTableView
                  show_pagination={false}
                  headers={[
                    {
                      key: "po_action",
                      value: " ",
                      type: FieldType.string,
                    },
                    {
                      key: "id",
                      value: "GRN",
                      type: FieldType.string,
                    },
                    {
                      key: "po_no",
                      value: "PO Number",
                      type: FieldType.string,
                    },
                    {
                      key: "party",
                      value: "Vendor Name",
                      type: FieldType.string,
                    },
                    {
                      key: "warehouse",
                      value: "Warehouse",
                      type: FieldType.string,
                    },
                    {
                      key: "due_date",
                      value: "Delivery Date",
                      type: FieldType.date,
                    },
                    {
                      key: "created_on",
                      value: "Created On",
                      type: FieldType.date,
                    },
                    {
                      key: "trq",
                      value: "Total Received QTY",
                      type: FieldType.number,
                    },
                    {
                      key: "top",
                      value: "Total PO QTY",
                      type: FieldType.number,
                    },
                  ]}
                  rows={inwardList.map((data, i) => ({
                    data: data,
                    cells: [
                      // {
                      //   builder: () => (
                      //     <button
                      //       onClick={() => {
                      //         navigation.push(
                      //           `${urls.purchase_voucher}/detail-screen/${data.id}` +
                      //           `?po_no=${data.order_detail?.po_no ?? ""}`
                      //         );
                      //       }}
                      //       className="relative text-sm font-semibold text-blue-400 hover:text-blue-500 whitespace-nowrap sticky-field  flex items-center gap-1 px-2 h-full w-full"
                      //     >
                      //       <div>{data.id}</div>
                      //     </button>
                      //   ),
                      // },

                      {
                        builder: () => {
                          const id = data.id ?? "";

                          const baseUrl = id.startsWith("PUR-")
                            ? urls.purchase_voucher
                            : id.startsWith("SRN-")
                              ? urls.purchase_service_voucher
                              : urls.purchase_voucher; // fallback

                          return (
                            <button
                              onClick={() => {
                                navigation.push(
                                  `${baseUrl}/detail-screen/${id}?po_no=${data.order_detail?.po_no ?? ""}`,
                                );
                              }}
                              className="relative text-xs font-semibold text-blue-400 hover:text-blue-500 whitespace-nowrap sticky-field flex items-center gap-1 px-2 h-full w-full"
                            >
                              <div>{id}</div>
                            </button>
                          );
                        },
                      },

                      { value: data?.order_detail?.po_no ?? "--" },
                      { value: data?.party_detail?.name ?? "--" },
                      { value: data?.warehouse?.name ?? "--" },
                      { value: data?.due_date },
                      { value: data?.created_at },
                      { value: data?.total_received_qty ?? 0 },
                      { value: data?.total_po_qty ?? 0 },
                    ],
                  }))}
                  page={1}
                  total={0}
                  count={50}
                  itemCount={inwardList?.length}
                  onPageChange={() => {}}
                  onShowHistory={() => {}}
                />
              </div>
            </section>
          )}
        </div>

        <div className="mt-3 w-full rounded-t-md bg-white shadow-sm py-3 px-5 border">
          <h3 className="text-sm font-semibold">Approval status</h3>
          <PoViewBottomSheetWidget data={purchaseOrder} />
        </div>
      </div>
      {id &&
        !showDisputeActionsOnly &&
        !isWarehouseOperator &&
        !procuremntRead && (
          <div className="fixed flex flex-col gap-2 bottom-10 pb-5 right-3">
            {purchaseOrder.approval_level ===
              purchaseOrder.current_approval_level &&
              (purchaseOrder.current_approval_count ?? 0) >=
                (purchaseOrder.current_approval_required_count ?? 0) && (
                <button
                  id="po_detail_print_btn"
                  title="print"
                  onClick={() => setShowSnaps(true)}
                  className="  rounded-full p-1 md:p-2  hover:scale-105 transform duration-150 bg-green-400 text-white   shadow cursor-pointer flex items-center justify-center"
                >
                  <Icon
                    path={mdiPrinter}
                    className="hover:scale-105 transform h-4 w-4 md:h-6 md:w-6"
                  ></Icon>
                </button>
              )}
            <button
              id="po_detail_attachments_btn"
              title="Attachments"
              onClick={() => setShowAttachment(true)}
              className="  rounded-full p-1 md:p-2 hover:scale-105 transform duration-150 bg-green-400 mb-15 text-white   shadow cursor-pointer flex items-center justify-center"
            >
              <Icon
                path={mdiAttachment}
                className="hover:scale-105 transform -rotate-45 h-4 w-4 md:h-6 md:w-6"
              ></Icon>
            </button>
          </div>
        )}
      {loading && <LoadingWidget />}
      <ModalDialog
        id="po_detail_resolve_dispute_modal"
        show={showResolveDisputeModal}
        title="Resolve Purchase Order Dispute"
        onClose={() => setShowResolveDisputeModal(false)}
      >
        <div className="p-6 flex flex-col gap-5">
          <div className="flex items-start gap-4">
            <div className="p-2 bg-green-100 rounded-full">
              <Icon
                path={mdiCheckCircleOutline}
                size={1.2}
                className="text-green-600"
              />
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-base font-semibold text-gray-900">
                Confirm Dispute Resolution
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                By resolving this dispute, you confirm that all issues have been
                addressed. Warehouse personnel will be able to proceed with
                successful inward operations for this Purchase Order.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
              Remark <RequiredMark />
            </label>
            <textarea
              id="po_detail_resolve_dispute_remark"
              value={resolveRemark}
              onChange={(e) => setResolveRemark(e.target.value)}
              placeholder="Enter reason for resolving this dispute..."
              className="w-full h-24 p-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 resize-none"
            />
          </div>

          <div className="flex justify-end gap-3 mt-2">
            <button
              id="po_detail_resolve_dispute_cancel_btn"
              onClick={() => {
                setShowResolveDisputeModal(false);
                setResolveRemark("");
              }}
              className="px-5 py-2 text-sm font-medium border border-gray-300 rounded-md hover:bg-gray-50 transition-colors text-gray-700"
            >
              Cancel
            </button>
            <button
              id="po_detail_resolve_dispute_confirm_btn"
              disabled={!resolveRemark.trim() || loading}
              onClick={handleResolveDispute}
              className={`px-5 py-2 text-sm font-medium rounded-md shadow-sm transition-all active:scale-95 ${
                !resolveRemark.trim() || loading
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-green-500 text-white hover:bg-green-600"
              }`}
            >
              {loading ? "Resolving..." : "Confirm Resolve"}
            </button>
          </div>
        </div>
      </ModalDialog>
    </>
  );
};

export default PurchaseOrderDetailScreen;
